import { auth } from './firebase';

export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8080';

/** Build a versioned API URL. Usage: apiUrl('/health/logs') → 'http://localhost:8080/api/v1/health/logs' */
export function apiUrl(path: string): string {
  return `${API_URL}/api/v1${path}`;
}

/**
 * Build auth headers for API requests.
 * Returns headers with Authorization if a user is signed in.
 */
export async function buildAuthHeaders(): Promise<HeadersInit> {
  const headers: HeadersInit = { 'Content-Type': 'application/json' };

  const user = auth.currentUser;
  if (user) {
    const token = await user.getIdToken();
    headers['Authorization'] = `Bearer ${token}`;
  }

  return headers;
}
